/**
 * Centralized error handler utility for API calls
 */
import { DEBUG_MODE } from "./config";

export const isNotFoundError = (error) => {
  return error?.response?.status === 404;
};
/**
 * Handle API errors consistently across the application
 * @param {Error} error - The error object from axios
 * @param {Object} options - Optional configuration
 * @param {Function} options.setLoading - Function to set loading state to false
 * @param {Function} options.setError - Function to set error message
 * @param {string} options.errorMessage - Custom error message to display
 * @param {boolean} options.silent - If true, don't log even in debug mode
 */
export const handleApiError = (error, options = {}) => {
  const { setLoading, setError, errorMessage, silent = false } = options;

  // Log error in debug mode
  if (!silent && DEBUG_MODE) {
    console.error(
      "API Error:",
      error?.response?.data || error?.message || error
    );
  }

  // Reset loading state if provided
  if (typeof setLoading === "function") {
    setLoading(false);
  }

  // Set error message if provided
  if (typeof setError === "function") {
    const message =
      errorMessage || error?.response?.data?.message || "An error occurred";
    setError(message);
  }
};

/**
 * Create a catch handler with pre-configured options
 * @param {Object} options - Configuration options
 * @returns {Function} - Catch handler function
 */
export const createErrorHandler = (options = {}) => {
  return (error) => handleApiError(error, options);
};

export default {
  handleApiError,
  createErrorHandler,
  isNotFoundError,
};
